// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1Kq6U","col":"styles_col__2WC0v"};